@import "../../theme/global";
$button-padding-top:         var(--lar-button-padding-top, 1rem) !default;
$button-padding-right:       var(--lar-button-padding-right, 1rem) !default;
$button-padding-bottom:      var(--lar-button-padding-bottom, 1rem) !default;
$button-padding-left:        var(--lar-button-padding-left, 1rem) !default;

$button-font-size:           var(--lar-button-font-size, 1.2rem) !default;

.thermostat-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem 1rem;
  gap: 1.5rem;
}

.temp-display {
  position: relative;
  width: 100%;
  max-width: 340px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
  gap: 1rem;
}

.temp-ring {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.05) 0%,
    rgba(255, 255, 255, 0) 50%,
    rgba(0, 0, 0, 0.03) 100%
  );
  box-shadow:
    inset 0 2px 8px rgba(0, 0, 0, 0.1),
    inset 0 -2px 4px rgba(255, 255, 255, 0.05),
    0 8px 32px -8px rgba(0, 0, 0, 0.15);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.temp-ring::before {
  content: "";
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  background: $background-color;
  box-shadow:
    0 4px 16px -4px rgba(0, 0, 0, 0.2),
    inset 0 2px 4px rgba(255, 255, 255, 0.1);
}

.temp-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.3rem;
}

.temp-value {
  font-size: 4rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.03em;
  text-shadow:
    0 2px 4px rgba(0, 0, 0, 0.1),
    0 0 1px rgba(255, 255, 255, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.temp-label {
  font-size: 0.85rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  opacity: 0.6;
}

.temp-controls {
  position: relative;
  z-index: 3;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.temp-controls lar-button {
  width: 3.5rem;
  height: 3.5rem;
  border-radius: 50%;
  font-size: 1.8rem;
  font-weight: 400;
  box-shadow:
    0 4px 12px -4px rgba(0, 0, 0, 0.2),
    0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.temp-controls lar-button:active {
  transform: scale(0.92);
}

lar-button-group {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 400px;
  padding: 0.4rem;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 0.8rem;
  box-shadow:
    inset 0 1px 3px rgba(0, 0, 0, 0.08),
    0 1px 0 rgba(255, 255, 255, 0.5);
}

lar-button-group lar-button {
  flex: 1;
  min-height: 3rem;
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-radius: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow:
    0 2px 8px -2px rgba(0, 0, 0, 0.15),
    0 1px 2px rgba(0, 0, 0, 0.1);
}

lar-button-group lar-button:active {
  transform: scale(0.97);
}

lar-button-group.setpoint {
  background: transparent;
  box-shadow: none;
  padding: 0;
  max-width: none;
}

.value {
  @include padding($button-padding-top, $button-padding-right, $button-padding-bottom, $button-padding-left);
  background-color: $background-color-step-150;
  font-size: $button-font-size;
  width: 25%;
  display: inline-block;
  color: $text-color;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden !important;
}

@mixin generate-thermostat-color($color-name) {
  $value: map-get($colors, $color-name);
  $base: map-get($value, base);
  $base-rgb: color-to-rgb-list($base);

  .lar-color-#{$color-name} .temp-ring {
    background: linear-gradient(
      135deg,
      rgba(var(--lar-color-#{$color-name}-rgb, #{$base-rgb}), 0.08) 0%,
      rgba(var(--lar-color-#{$color-name}-rgb, #{$base-rgb}), 0) 50%,
      rgba(0, 0, 0, 0.03) 100%
    );
    box-shadow:
      inset 0 0 0 3px rgba(var(--lar-color-#{$color-name}-rgb, #{$base-rgb}), 0.15),
      inset 0 2px 8px rgba(0, 0, 0, 0.1),
      inset 0 -2px 4px rgba(255, 255, 255, 0.05),
      0 0 24px -8px rgba(var(--lar-color-#{$color-name}-rgb, #{$base-rgb}), 0.2),
      0 8px 32px -8px rgba(0, 0, 0, 0.15);
  }

  .lar-color-#{$color-name} .temp-value {
    color: lar-color($color-name, base);
    text-shadow:
      0 2px 4px rgba(var(--lar-color-#{$color-name}-rgb, #{$base-rgb}), 0.2),
      0 0 2px rgba(var(--lar-color-#{$color-name}-rgb, #{$base-rgb}), 0.1);
  }
}

@each $color-name, $value in $colors {
  @include generate-thermostat-color($color-name);
}

